import React, { Component } from "react";
import { withRequest } from "../../../utils/request";
import { auth } from "../../../utils/auth";
import { apiUrl } from "../../../utils/apiUrl";
import Loader from "../../general/Loader";
import DescuentosForm from "./Form";
import Modal from "../../general/Modal";
import { toast } from "../../../utils/helpers";

class Descuentos extends Component {
    state = {
        descuentos: [],
        loading: true,
        showCreate: false,
        showDelete: false,
        descuentoId: null,
    };
    componentDidMount() {
        this.getDescuentos();
    }
    getDescuentos = async (url = null) => {
        const id = this.props.empleado.id;
        url = url ? url : `empleados/${id}/descuentos`;
        const descuentos = await this.props.request(url);

        if (descuentos.success) {
            this.setState({
                descuentos: descuentos.data,
                loading: false
            });
        }
    };
    removeDescuento = async () => {
        const { empleado } = this.props;
        const { descuentoId } = this.state
        const token = auth.getToken();

        const url = `empleados/${empleado.id}/descuentos/${descuentoId}`;

        const res = await fetch(apiUrl(url), {
            method: "delete",
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token
            }
        });

        const response = await res.json();

        if (response.success) {
            this.getDescuentos();
            toast('Descuento Borrado', 'success');
            return;
        } else {
            this.setState({ errors: response.data.message });
        }
    };
    toggleCreateModal = () => {
        this.setState({
            showCreate: !this.state.showCreate
        });
    };
    toggleDeleteModal = (id = null) => {
        this.setState({
            showDelete: !this.state.showDelete,
            descuentoId: id,
        });
    };
    render() {
        const { empleado } = this.props;
        const { descuentos, loading, descuentoId } = this.state;

        if (loading === 0) {
            return <Loader />;
        }
        return (
            <div>
                <div className='row m-b-20 descripcion-subpage'>
                    <div className='col'>
                        <h3>Descuentos Fijos</h3>
                        <p><small>Los descuentos fijos que se aplican en todas las nóminas que se generan. Útil para seguros adicionales y de familiares que se descuentan de manera fija.</small></p>
                    </div>
                    <div className='col-md-3 text-right'>
                        <button
                            onClick={this.toggleCreateModal}
                            className='au-btn au-btn-icon au-btn--green au-btn--small'>
                            Nuevo
                        </button>
                    </div>
                </div>
                <table className='table tickets-table'>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Monto</th>
                            <th>Descripción</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {descuentos.map(descuento => (
                            <tr key={descuento.id}>
                                <td>{descuento.nombre}</td>
                                <td>{descuento.monto}</td>
                                <td>{descuento.descripcion}</td>
                                <td>
                                    <button
                                        type="button"
                                        onClick={() => this.toggleDeleteModal(descuento.id)}>
                                        <i className='fa fa-trash-alt' />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Modal
                    show={this.state.showCreate}
                    blank={true}
                    toggle={this.toggleCreateModal}>
                    <DescuentosForm
                        toggle={this.toggleCreateModal}
                        empleadoId={empleado.id}
                        getDescuentos={this.getDescuentos}
                    />
                </Modal>
                <Modal
                    title='Borrar Descuento'
                    show={this.state.showDelete}
                    callback={this.removeDescuento}
                    acceptText='Borrar'
                    toggle={this.toggleDeleteModal}>
                    ¿Estás seguro de que deseas borrar este descuento?
                </Modal>
            </div>
        );
    }
}

export default withRequest(Descuentos);
